module.exports = {
  common: {
    save: '保存',
    cancel: '取消',
    combinationTitle: '自动放单规则（组合）',
    ruleTitle: '自动放单规则',
    AutomaticOrderReleaseTriggerSettings: '自动放单触发设置',
    ReleaseGuaranteeSetting: '放单保函设置',
    docType: '提单类型',
    customerSelfRelease: 'HBL类型',
    releaseType: '提单方式',
    cargoSource: '揽货来源',
    creditObject: '放单信控对象',
    receivableType: '收支类型',
    creditLimitedDate: '信控账期',
    creditLimitAmount: '信控额度',
    customerType: '委托单位类型',
    creditLimitedETD: '信控ETD'
  },
  selectBranch: '选择分公司：',
  ApplyTheHeadOfficeConfiguration: '应用总公司配置',
  enterRuleName: '请输入规则名称',
  add: '新增',
  edit: '编辑',
  deletes: '删除',
  refresh: '刷新',
  ruleName: '自动放单规则名称',
  businessTypes: '适用业务类型',
  conversionRules: '相关处理规则',
  ruleDescription: '描述',
  orderNum: '序号',
  ruleGroupName: '自动放单规则（组合）名称',
  ruleNames: '包含规则名称',
  performActions: '包含执行动作',
  officeCode: '分公司',
  customerCompany: '适用客户',
  refreshSuccess: '刷新成功',
  operationSuccess: '操作成功',
  dialogRuleName: '规则（组合）名称',
  RuleNamePlaceholder: '请输入规则名称',
  ruleDescriptionPlaceholder: '描述内容',
  AnyRuleTitle: '适用下列任意规则',
  AllRuleTitle: '适用下列所有规则',
  PerformRelatedActions: '执行相关动作',
  meetConditions: '满足条件',
  meetConditionsRemind: '满足放单条件时自动放单。（放单状态更新至"可放单"）',
  dissatisfaction: '不满足条件',
  runningRules: '运行下一条规则组合',
  runningRulesRemind: '未满足放单条件时不放单。（放单状态更新至"待收款"）',
  remark1: '备注：当所有组合"不满足条件"均选择"运行下一条规则组合"，且实际运行判断结果均为不满足条件时。',
  remark2: '放单状态也会更新至"待收款"',
  applicableCustomers: '适用客户',
  applicableCustomersRemind1: '自动放单仅适用于结算类型为“非票结”的客户',
  applicableCustomersRemind2: '(即有账期的客户)',
  conditionType: '条件类型',
  customerName: '客户名称',
  branchOffice: '分公司',
  successRemind: '保存成功',
  toggleReminder: '请再次确认是否要将适用客户切换至全部？ 此操作将清空下方列表客户信息。',
  tips: '提示',
  yes: '是',
  no: '否',
  deleteRemind: '请选择至少一条数据进行删除！',
  ruleName1: '规则名称',
  meetAnyConditions: '满足下列任意条件',
  meetAllConditions: '满足下列所有条件',
  processingRules: '放单处理规则',
  releaseDemand: '见款放单',
  prompt: '保存前请先维护${prompt}信息。',
  Tips1: '请完善规则信息',
  equal: '等于',
  neq: '不等于',
  exceed: '超过',
  notMore: '未超过',
  SC: '自揽货',
  NC: '指定货',
  creditUsedLimitAmount: '已用额度',
  creditLimitedETDDays: '信控ETD天数',
  customerIssuing: '客户自出单',
  issuedCompany: '公司自出单',
  original: '正本',
  telexRelease: '电放',
  accountingPeriod: '信控设置账期',
  client: '委托单位',
  agent: '指定货代理',
  settlement: '结算对象',
  collection: '收款',
  maintenanceName: '维护规则（组合）名称',
  rule: '规则',
  whole: '全部',
  TriggerTheNode: '触发节点',
  ScheduledPollingTriggersAutomaticOrderVerification: '定时轮询触发自动放单校验',
  ApplyBranchOfficeSettings: '应用分公司设置',
  automatic: '自动',
  daily: '每日',
  blacklist: '黑名单',
  EffectiveList: '生效名单',
  ChargeRecordState: '费用录入状态判断',
  ChargeRecordState0: '必须含有应收费用',
  ChargeRecordState1: '必须含有结算对象为委托单位的费用，无论收付',
  ChargeRecordState2: '无论是否有费用',
  SettlementBillMode: '见款放单模式',
  SettlementBillCheckCost: '无其他应收时，录入了向委托单位的应付，视为该票已付款',
  SettlementBillCustomer: '仅校验委托单位应收已核销',
  SettlementBillCustomerCheckCost: '无委托单位应收时，录入了向委托单位的应付，视为委托单位已付款',
  CreditObjectMode: '信控模式'
}
